module.exports = __webpack_public_path__ + "static/media/river-park-village-condos.b8b314e0.pdf";